import React, { useEffect, useState, useLayoutEffect } from 'react';
import fetchAPI from '../../../common/fetchAPI';
import { t } from "i18next";
import clsx from 'clsx';
import { formatDateWithDateAndMonthName, getPageSizeArray, setItemStatus, paginationStyles, getValueFromResource, sortData } from '../../../common/timeLiveFunction';
import moment from 'moment';
import Select, { StylesConfig } from 'react-select';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Dropdown } from 'react-bootstrap';
import { useDebounce } from '../../../_metronic/helpers';
import CustomPagination from "../../../common/Pagination";
import Loader from '../../../common/Loader';
import { useNavigate, useLocation } from "react-router-dom";
import { getPagePermissionsAsync, updateGoogleCalendarTaskManualSync, updateOutlookCalendarTaskManualSync } from '../../../common/GlobalSlice';
import PageSizeSelect from '../../../common/PageSizeSelect';
import TaskFilterOffCanvas from '../../../common/OffCanvas';
import TaskFilters from './MyTaskFilters';

import { sendToGoogleCalendarAsync, sendToOutlookCalendarAsync } from '../../admin/integrations/IntegrationSlice';
import { ShowSwalForCanvas, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { updateIsLoading } from '../TaskSlice';
import { ShowToast } from '../../../common/Toastr';

let initialValues = {
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    // isSearch: false,
    isLoading: true,
    IsAllMyTask: false,
    IsAddMyTask: false,
    IsEditMyTask: true,
    sortOrder: 'asc',
    sortColumn: 'TaskName'
}

const MyTask = (props: any) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [myTaskList, setMyTaskList] = useState<any[]>([]);
    const [myTaskListValues, setMyTaskListValues] = useState(initialValues);
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
    const [TaskIds, setTaskIds] = useState(Array<any>);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const currentDate = new Date();
    const { FilterValues } = useAppSelector((state) => state.task);
    const [IsParentTask, setIsParentTask] = useState(false);
    const [childs, setChilds] = useState(initialValues);
    // const { status, widgetFilters, fromDashboard } = location.state || {};
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");
    const parsedState = encoded ? JSON.parse(decodeURIComponent(encoded)) : {};
    const { widgetFilters = null,fromDashboard = false,status = null, IsOverdue = 0} = parsedState;

    // const [hoveredColumn, setHoveredColumn] = useState(null);
    const { cultureInfoName, pageId, menuList, maxMenuHeight, showProjectNameInTask, showClientNameInTask, timeZoneId, isGoogleCalendarTaskManualSync, isOutlookCalendarTaskManualSync, dateInsertionFormat, enableUploadFeature } = useAppSelector((state) => state.globalState);

    const { isLoading } = useAppSelector((state) => state.integration);
    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        }
        getCustomPagePermissionsAsync("28");
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    // useEffect(() => {
    //     renderMyTaskList();
    // }, [myTaskListValues.pageNo, myTaskListValues.pageSize, myTaskListValues.isSearch]);

    const debouncedSearch = useDebounce(myTaskListValues.search, 1000);
    const debouncedPageNo = useDebounce(myTaskListValues.pageNo, 500); // 300ms debounce
    const debouncedPageSize = useDebounce(myTaskListValues.pageSize, 500);

    const onHandleSearch = (event: any) => {
        setMyTaskListValues({
            ...myTaskListValues,
            search: event.target.value
        });
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        setMyTaskListValues({
            ...myTaskListValues,
            startRec: 0,
            pageSize: selectedOption.value,
            pageNo: 1,
        });
    };

    const onHandlePageChange = (pageNumber: any) => {
        setMyTaskListValues({
            ...myTaskListValues,
            startRec: (pageNumber - 1) * Number(myTaskListValues.pageSize),
            pageNo: pageNumber,
        });
    };

    // useEffect(() => {
    //     renderMyTaskList();
    //     getIntegrationAsync();
    // }, [myTaskListValues.pageNo, myTaskListValues.pageSize, myTaskListValues.search, FilterValues]);



    useEffect(() => {
        renderMyTaskList();
        getIntegrationAsync("Google", "3B00775F-9B50-4A7D-926F-1192E2E3033E");
        getIntegrationAsync("Outlook", "6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828");
    }, [debouncedPageNo, debouncedPageSize, debouncedSearch, FilterValues]);

    const getIntegrationAsync = async (type: "Google" | "Outlook", systemIntegrationId: string) => {
        const response = await fetchAPI(`api/V2/Integrations/Integration/${type}/${systemIntegrationId}`, "GET", "", true, "");
        const json = await response.json();

        if (type === "Google") {
            dispatch(updateGoogleCalendarTaskManualSync(json.IsTaskManual));
        } else {
            dispatch(updateOutlookCalendarTaskManualSync(json.IsTaskManual));
        }
    };

    const renderMyTaskList = async () => {
        const { startRec, pageSize, pageNo, search } = myTaskListValues;

        let SearchParamsValues = `0,0,-1,0,0,0,,false,${moment(currentDate).format(dateInsertionFormat)},${moment(currentDate).format(dateInsertionFormat)},1`;

        const ObjTaskFilters: any = FilterValues
        const {
            AccountProjectId,
            AccountTaskTypeId,
            AccountCompleteStatusId,
            AccountMilestoneId,
            AccountStatusId,
            StartDate,
            EndDate,
            IncludeDateRange, Description, IsDisabled } = ObjTaskFilters;


        if (FilterValues) {
            const ObjTaskFilters: any = FilterValues || {};
            const wf = widgetFilters || {};
            const StatusIds = status && status.length > 0 ? status.join(',') : ObjTaskFilters.AccountStatusId;
            const AccountPriorityId = wf?.AccountPriorityId !== undefined ? wf?.AccountPriorityId[0] : 0;
            const AccountProjectId = wf.AccountProjectId !== undefined ? wf.AccountProjectId[0] : ObjTaskFilters.AccountProjectId;
            const AccountTaskTypeId = wf.AccountTaskTypeId !== undefined ? wf.AccountTaskTypeId[0] : ObjTaskFilters.AccountTaskTypeId;
            const IncludeDateRange = wf.IncludeDateRange !== undefined ? (wf.IncludeDateRange ? 1 : 0) : (ObjTaskFilters.IncludeDateRange ? 1 : 0);
            const StartDate = IncludeDateRange === 1 ? (wf?.DateRange?.startDate ? moment(wf?.DateRange?.startDate).format(dateInsertionFormat) : moment(ObjTaskFilters.StartDate).format(dateInsertionFormat)) : moment(ObjTaskFilters.StartDate).format(dateInsertionFormat);
            const EndDate = IncludeDateRange === 1 ? (wf?.DateRange?.endDate ? moment(wf?.DateRange?.endDate).format(dateInsertionFormat) : moment(ObjTaskFilters.EndDate).format(dateInsertionFormat)) : moment(ObjTaskFilters.EndDate).format(dateInsertionFormat);

            SearchParamsValues = `${AccountProjectId},${AccountTaskTypeId},${AccountCompleteStatusId},${AccountMilestoneId},'${StatusIds}',${AccountPriorityId},${Description},${IncludeDateRange},${StartDate},${EndDate},${IsDisabled},${IsOverdue}`;
            // SearchParamsValues = `${AccountProjectId},${AccountTaskTypeId},${AccountCompleteStatusId},${AccountMilestoneId},'${StatusIds}',${AccountPriorityId},${Description},${IncludeDateRange},${StartDate},${EndDate},${IsDisabled}`;
            // SearchParamsValues = `${AccountProjectId},${AccountTaskTypeId},${AccountCompleteStatusId},${AccountMilestoneId},${StatusIds},${Description},${IncludeDateRange},${moment(StartDate).format(dateInsertionFormat)},${moment(EndDate).format(dateInsertionFormat)},${IsDisabled}`;
            // SearchParamsValues = `${AccountProjectId},${AccountTaskTypeId},${AccountCompleteStatusId},${AccountMilestoneId},${AccountStatusId},${Description},${IncludeDateRange},${moment(StartDate).format(dateInsertionFormat)},${moment(EndDate).format(dateInsertionFormat)},${IsDisabled}`;

        }
        const response = await fetchAPI(`api/V2/Tasks/GetMyTasksDatatable/${SearchParamsValues}/${startRec}/${pageSize}/${pageNo}/${search}`, 'Get', '', true);
        const json = await response.json();
        let myTaskList: any[] = [];
        // if (json != undefined) {
        if (json?.data) {
            myTaskList = json?.data ? JSON.parse(json.data) : [];
            // let myTaskList = JSON.parse(json.data);
            const isParentTaskPresent = myTaskList.some((task: any) => {

                // Convert possible values to boolean
                return task.IsParentTask === true ||
                    task.IsParentTask === "true" ||
                    task.IsParentTask === 1;
            });

            // Update the state
            setIsParentTask(isParentTaskPresent);
            if (isParentTaskPresent) {
                setMyTaskList(myTaskList);

            } else {
                setMyTaskList(sortData(myTaskList, myTaskListValues.sortOrder, myTaskListValues.sortColumn));
            }
            //setMyTaskList(myTaskList);
            //setMyTaskList(sortData(myTaskList, myTaskListValues.sortOrder, myTaskListValues.sortColumn));
            // setMyTaskListValues({
            //     ...myTaskListValues,
            //     pageNo: json.currentPage,
            //     startRec: json.start,
            //     totalItems: json.recordsFiltered,
            //     search: json.searchText,
            //     recordsFiltered: json.recordsFiltered,
            //     isLoading: false
            // }));      
            setMyTaskListValues(prevValues => ({
                ...prevValues,
                pageNo: json.currentPage,
                startRec: json.start,
                totalItems: json.recordsFiltered,
                search: json.searchText,
                recordsFiltered: json.recordsFiltered,
                isLoading: false
            }));
            setIsFirstTimeLoad(false);
        }
    }

    const getCustomPagePermissionsAsync = async (arg: string) => {
        const response = await fetchAPI('api/v2/PagePermission/GetCustomPagePermissions/?value=' + arg, 'Get', '', true);
        const json = await response.json();
        if (json.length > 0) {
            /*             setMyTaskListValues({
                            ...myTaskListValues,
                            IsAllMyTask: json.filter((x: any) => x.Id === 28)[1].IsAll,
                            IsAddMyTask: json.filter((x: any) => x.Id === 28)[2].IsAdd,
                            IsEditMyTask: json.filter((x: any) => x.Id === 28)[3].IsEdit,
                            isLoading: false
                        }); */
            setChilds({
                ...childs,
                IsAllMyTask: json[0].IsList,
                IsEditMyTask: json[0].IsList,
                isLoading: false
            });
        }
    }

    // const debouncedSearchTerm = useDebounce(myTaskListValues.search, 500);
    // useEffect(() => {
    //     if (!isFirstTimeLoad) {
    //         renderMyTaskList();
    //     }
    // }, [debouncedSearchTerm]);


    // const debouncedSearchTerm = useDebounce(myTaskListValues.search, 1000);

    //         useEffect(() => {
    //          if (!isFirstTimeLoad) {
    //              renderMyTaskList();
    //          }
    //     }, [debouncedSearchTerm]);






    // const onHandlePageSizeChange = (selectedOption: any) => {        
    //     setMyTaskListValues({
    //         ...myTaskListValues,
    //         startRec: 0,
    //         pageSize: selectedOption.value,
    //         pageNo: 1,
    //         search: myTaskListValues.search
    //     });
    // }

    // const onHandlePageChange = (pageNumber: any) => {       
    //     setMyTaskListValues({
    //         ...myTaskListValues,
    //         startRec: (pageNumber - 1) * Number(myTaskListValues.pageSize),
    //         pageSize: myTaskListValues.pageSize,
    //         pageNo: pageNumber,
    //         search: myTaskListValues.search
    //     });
    // }

    const navigateToAccountProjectTaskSummary = (obj: any) => {
        localStorage.setItem('objTask', JSON.stringify(obj));
        navigate(`/accountprojecttasksummary/${obj.AccountProjectId}/${obj.AccountProjectTaskId}?from=mytask`);
        // navigate('/accountprojecttasksummary', { state: { obj } });
    }

    const navigateToTaskRequestHoursFrom = (obj: any) => {
        navigate('/taskrequesthours', { state: { obj } });
        // navigate('/accountprojecttasksummary', { state: { obj } });
    }

    const navigateToAudit = (AccountProjectTaskId: any) => {
        const obj = {
            Id: AccountProjectTaskId,
            TableName: 'AccountProjectTask',
            Title: getValueFromResource('Project Task Audit', dispatch, t)
        }
        // navigate('/accountaudit', { state: { obj } });
        navigate(`/accountaudit/${AccountProjectTaskId}`, { state: { obj } })

    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    const onHandleClientSideSorting = (orderDir: string, orderColumn: string) => {
        setMyTaskListValues({
            ...myTaskListValues,
            sortOrder: orderDir,
            sortColumn: orderColumn
        });
        let sortedTeamResponse = [...myTaskList];
        setMyTaskList(sortData(sortedTeamResponse, orderDir, orderColumn));
    }


    const sendToOutlookCalendar = async () => {
        if (TaskIds.length === 0) {
            ShowSwalForCanvas('Outlook Calendar Action', 'Please select at least one record to Outlook Calendar.', 'warning');
            return;
        }

        ShowSwalWithConfirmation("Confirmation Required", 'Are you sure you want to send the selected records to Outlook Calendar?', "Confirm")
            .then((result) => {
                if (result) {
                    if (TaskIds.length !== 0) {
                        dispatch(sendToOutlookCalendarAsync({
                            commaSeparatedIds: TaskIds.join(','),
                            exportType: 'Task',
                            timeZoneId: timeZoneId
                        })).then((result) => {
                            ShowToast('Success', 'Successfully Integrated.', "success", "toast-top-right");
                            setTaskIds([]);
                            setIsAllChecked(false);

                        });
                    }
                }
            })
            .catch((error) => {
                dispatch(updateIsLoading(false));
                ShowToast('Error', 'An unexpected error occurred. Please try again later.', "error", "toast-top-right");
            });
    };



    const sendToGoogleCalendar = async () => {
        if (TaskIds.length === 0) {
            ShowSwalForCanvas('Google Calendar Action', 'Please select at least one record to Outlook Calendar.', 'warning');
            return;
        }

        ShowSwalWithConfirmation("Confirmation Required", `Are you sure you want to send the selected record's to Google Calendar`, "Confirm")
            .then((result) => {
                if (result) {
                    if (TaskIds.length !== 0) {

                        dispatch(sendToGoogleCalendarAsync({ commaSeparatedIds: TaskIds.join(','), exportType: 'Task', timeZoneId: timeZoneId })).then((result) => {
                            ShowToast('Success', 'Successfully Integrated.', "success", "toast-top-right");
                            setTaskIds([]);
                            setIsAllChecked(false);
                        })
                    }
                }
            })
            .catch((error) => {
                dispatch(updateIsLoading(false));
            });
    }



    const handleAllCalendarCheckboxChange = (e: any) => {
        let isChecked = e.target.checked;
        setAllMyTaskIdsState(isChecked);
        // console.log('handleAllCalendarCheckboxChange',isChecked)
    }

    const setAllMyTaskIdsState = (isChecked: any) => {
        if (isChecked) {
            // Add all IDs to selectedIds
            setTaskIds(myTaskList.map((item: any) => item.AccountProjectTaskId))
        } else {
            // Clear all selected IDs
            setTaskIds([]);
        }
        setIsAllChecked(isChecked);
    }

    const handleCalendarCheckboxChange = (e: any, AccountProjectTaskId: any) => {
        let isChecked = e.target.checked;
        setTaskIdsState({ AccountProjectTaskId, isChecked });
    }

    const setTaskIdsState = (obj: any) => {

        const { AccountProjectTaskId, isChecked } = obj;

        if (isChecked) {
            // Add the ID to the selectedIds array if it's not already present
            if (!TaskIds.includes(AccountProjectTaskId)) {
                //TaskIds.push(AccountProjectTaskId);
                setTaskIds(prevTaskIds => [
                    ...prevTaskIds,    // Spread the previous values in the array
                    AccountProjectTaskId  // Add the new task ID to the array
                ]);
            }
        } else {
            // Remove the ID from the selectedIds array if it's present
            setTaskIds(TaskIds.filter(Id => Id !== AccountProjectTaskId))
        }
        // Check if all items are selected
        const totalItems = myTaskList.length;
        const selectedItemCount = TaskIds.length + 1;

        // Update 'isAllChecked' based on the selection
        setIsAllChecked(totalItems > 0 && selectedItemCount === totalItems);
    }

    const generalObject = {
        "name": getValueFromResource("Filters", dispatch, t),
        "width": "500px",
        "componentName": <TaskFilters t={t} />
    }



    return (
        <>
            {(myTaskListValues.isLoading || isLoading) && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('My Task List')} */}
                        {getValueFromResource('My Task List', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        {myTaskList.length > 0 && <>
                            {isOutlookCalendarTaskManualSync && <>

                                <button
                                    type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                    onClick={() => {
                                        sendToOutlookCalendar();
                                    }}
                                >
                                    {/* {t('Send To Google Calendar')} */}
                                    {getValueFromResource('Send To Outlook Calendar', dispatch, t)}
                                </button>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            </>}
                            {isGoogleCalendarTaskManualSync && <>

                                <button
                                    type="button"
                                    className="btn btn-success btn-bs-btn-font-weight btn-sm"
                                    onClick={() => {
                                        sendToGoogleCalendar();
                                    }}
                                >
                                    {/* {t('Send To Google Calendar')} */}
                                    {getValueFromResource('Send To Google Calendar', dispatch, t)}
                                </button>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            </>}
                        </>}

                        <div className="position-relative">
                            <input
                                type="text"
                                value={myTaskListValues.search}
                                onChange={onHandleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={paginationStyles}
                                maxMenuHeight={maxMenuHeight}
                                options={getPageSizeArray()}
                                value={getPageSizeArray().find((option: any) => option.value == myTaskListValues.pageSize)}
                                onChange={onHandlePageSizeChange}
                                className='fs-7 fw-normal'
                            /> */}
                            <PageSizeSelect onChange={onHandlePageSizeChange} />


                        </div>
                        {(myTaskList.length > 0) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null}
                        <div>
                            {(myTaskList.length > 0) ? (
                                <CustomPagination
                                    currentPage={myTaskListValues.pageNo}
                                    onPageChange={onHandlePageChange}
                                    pageSize={myTaskListValues.pageSize}
                                    totalItems={myTaskListValues.totalItems}
                                    start={myTaskListValues.startRec}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>

                        <div className='bullet bg-secondary h-35px w-1px mx-3'
                        >
                        </div>
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            // data-tooltip-content={t("Filters")}
                            data-tooltip-content={getValueFromResource('Filters', dispatch, t)}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>

                    </div>
                </div>
                {/* <div className='card-body py-3'> */}
                <div className='card-Report-body py-3'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className='thHeading align-middle'>
                                    {(isGoogleCalendarTaskManualSync || isOutlookCalendarTaskManualSync) && (

                                        <th className='w-25px'>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                <input
                                                    className='form-check-input widget-9-check'
                                                    type='checkbox'
                                                    checked={isAllChecked}
                                                    onChange={(e) => { handleAllCalendarCheckboxChange(e) }}
                                                />
                                            </div>
                                        </th>
                                    )}
                                    <th style={{ width: '10%' }}
                                    // onMouseEnter={() => handleMouseEnter(0)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Active / Inactive")} */}
                                        {getValueFromResource('Active / Inactive', dispatch, t)}
                                        {myTaskListValues.sortColumn === 'IsDisabled' ?
                                            myTaskListValues.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 0 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {getValueFromResource("Task Name", dispatch, t)}
                                        {IsParentTask ? (
                                            // Display a lock icon for parent tasks
                                            <span className="cursor">
                                                <i className="bi bi-lock fs-6" title="Sorting disabled for parent tasks"></i>
                                            </span>
                                        ) : (
                                            myTaskListValues.sortColumn === 'TaskName' ? (
                                                myTaskListValues.sortOrder === 'asc' ? (
                                                    <span
                                                        className="headerSortIconBG cursor"
                                                        onClick={() => onHandleClientSideSorting("desc", "TaskName")}
                                                    >
                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                ) : (
                                                    <span
                                                        className="headerSortIconBG cursor"
                                                        onClick={() => onHandleClientSideSorting("asc", "TaskName")}
                                                    >
                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                    </span>
                                                )
                                            ) : (
                                                <>
                                                    <span
                                                        className="cursor"
                                                        onClick={() => onHandleClientSideSorting("asc", "TaskName")}
                                                    >
                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span
                                                        className="cursor"
                                                        onClick={() => onHandleClientSideSorting("desc", "TaskName")}
                                                    >
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>
                                            )
                                        )}
                                    </th>
                                    {showClientNameInTask && <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(2)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Client")} */}
                                        {getValueFromResource('Client', dispatch, t)}
                                        {myTaskListValues.sortColumn === 'PartyName' ?
                                            myTaskListValues.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PartyName") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PartyName") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 2 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "PartyName") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "PartyName") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>}
                                    {showProjectNameInTask && <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(3)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Project")} */}
                                        {getValueFromResource('Project', dispatch, t)}
                                        {myTaskListValues.sortColumn === 'ProjectName' ?
                                            myTaskListValues.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 3 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>}
                                    <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(4)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Code")} */}
                                        {getValueFromResource('Code', dispatch, t)}
                                        {myTaskListValues.sortColumn === 'TaskCode' ?
                                            myTaskListValues.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskCode") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskCode") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 4 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskCode") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskCode") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(5)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Status")} */}
                                        {getValueFromResource('Status', dispatch, t)}
                                        {myTaskListValues.sortColumn === 'TaskStatus' ?
                                            myTaskListValues.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskStatus") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskStatus") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 5 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskStatus") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskStatus") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(6)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Priority")} */}
                                        {getValueFromResource('Priority', dispatch, t)}
                                        {myTaskListValues.sortColumn === 'Priority' ?
                                            myTaskListValues.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Priority") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Priority") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 6 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Priority") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Priority") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {myTaskList.length > 0 && myTaskList.map((item: any) => {
                                    return (
                                        <tr key={item.AccountProjectTaskId}>
                                            {(isGoogleCalendarTaskManualSync || isOutlookCalendarTaskManualSync) && (
                                                <td>
                                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                        <input
                                                            className='form-check-input widget-9-check'
                                                            type='checkbox'
                                                            checked={TaskIds.includes(item.AccountProjectTaskId)}
                                                            onChange={(e) => { handleCalendarCheckboxChange(e, item.AccountProjectTaskId) }}
                                                        />
                                                    </div>
                                                </td>
                                            )}
                                            <td>
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === true ? "InActive" : "Active"))}>
                                                    {item.IsDisabled === true ? "InActive" : "Active"}
                                                </span>
                                            </td>
                                            <td>
                                                <a className='text-dark fw-bold d-block cursor'
                                                    onClick={() => {
                                                        myTaskListValues.IsEditMyTask === true && navigateToAccountProjectTaskSummary({
                                                            "AccountProjectId": item.AccountProjectId,
                                                            "AccountProjectTaskId": item.AccountProjectTaskId
                                                        });
                                                    }}
                                                    style={{
                                                        paddingLeft: `${item.Level * 20}px`,  // Dynamic indentation based on Level
                                                        textDecoration: item.IsParentTask ? 'underline' : 'none', // Conditional underline
                                                    }}
                                                >
                                                    {item.TaskName}
                                                </a>
                                                <span
                                                    style={{
                                                        color: '#7b8ba6',
                                                        fontSize: 11,
                                                        paddingLeft: `${item.Level * 20}px`,  // Dynamic indentation based on Level
                                                    }}>
                                                    {/* {`${moment.parseZone(item.StartDate).format('DD MMM yy')} - ${moment.parseZone(item.DeadlineDate).format('DD MMM yy')}`} */}
                                                    {formatDateWithDateAndMonthName(item.StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(item.DeadlineDate, cultureInfoName.toString())}

                                                </span>
                                            </td>
                                            {showClientNameInTask && <td>
                                                <a className='text-gray-800 d-block'>
                                                    {item.PartyName}
                                                </a>
                                            </td>}
                                            {showProjectNameInTask && <td>
                                                <a className='text-gray-800 d-block'>
                                                    {item.ProjectName}
                                                </a>
                                            </td>}
                                            <td>
                                                <a className='text-gray-800 d-block'>
                                                    {item.TaskCode}
                                                </a>
                                            </td>
                                            <td>
                                                <span className={`badge fs-7 ${setItemStatus(item.TaskStatus)}`}>{item.TaskStatus}</span>
                                            </td>
                                            <td>
                                                <a className='text-gray-800 d-block'>
                                                    {item.Priority}
                                                </a>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {t("More")}
                                                        {getValueFromResource('More', dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0"
                                                                onClick={() => {
                                                                    navigateToAccountProjectTaskSummary({
                                                                        "AccountProjectId": item.AccountProjectId,
                                                                        "AccountProjectTaskId": item.AccountProjectTaskId,
                                                                        "IsSummaryFrom": 'view'
                                                                    });
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-file-earmark-text fs-4 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('View Task')}`} */}
                                                                    {getValueFromResource('View Task', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0"
                                                                onClick={() => {
                                                                    navigateToAccountProjectTaskSummary({
                                                                        "AccountProjectId": item.AccountProjectId,
                                                                        "AccountProjectTaskId": item.AccountProjectTaskId,
                                                                        "IsSummaryFrom": 'team'
                                                                    });
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-person-plus fs-4 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Team')}`} */}
                                                                    {getValueFromResource('Team', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        {enableUploadFeature &&
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => {
                                                                        navigateToAccountProjectTaskSummary({
                                                                            "AccountProjectId": item.AccountProjectId,
                                                                            "AccountProjectTaskId": item.AccountProjectTaskId,
                                                                            "IsSummaryFrom": 'attachment'
                                                                        });
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-paperclip fs-4 iconColor">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Attachment')}`} */}
                                                                        {getValueFromResource('Attachment', dispatch, t)}
                                                                    </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        }
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => navigateToAudit(item.AccountProjectTaskId)}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-receipt fs-6 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Audit')}`} */}
                                                                    {getValueFromResource('Audit', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0"
                                                                onClick={() => {
                                                                    navigateToTaskRequestHoursFrom({
                                                                        "AccountProjectTaskId": item.AccountProjectTaskId
                                                                    })
                                                                    // navigate('/taskrequesthours');
                                                                    // navigate('/taskrequesthours', { state: { "AccountProjectTaskId": item.AccountProjectTaskId } });

                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-clock fs-6 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Task Hours Request')}`} */}
                                                                    {getValueFromResource('Task Hours Request', dispatch, t)}

                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </Dropdown.Menu>

                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {myTaskList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}

                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <TaskFilterOffCanvas obj={generalObject} />
        </>
    )
}
export default MyTask 